module.exports = __webpack_public_path__ + "static/media/take-style-quiz.f62090ef.png";